import { profileConstants } from "../_constants";
import { metadataService } from "../_services";
const profileIntitalState = {
    userProfile: {},
    originalProfile:{}, 
    profileLoaded: false, 
    residentialBasis: {}, 
    residentialBasisLoaded: false , 
    financialInfo : {}, 
    employers : [], 
    incomes : [],
    savingExtendedProfile : false,  
} ;

export function  profile(state = profileIntitalState, action) 
{
    
    switch(action.type){
        case profileConstants.LOAD_PROFILE_SUCCESS:
            const newProfile = action.profile; 
            newProfile.profileType = 4; //Set to SaveProfile ... for saving. 
            newProfile.saveMobile = false; 
            newProfile.saveAddress = false; 
            newProfile.rentOrOwn = action.profile.ownResidence === true  ? 1 : 0;
            const {    
                employers,
                incomes,
                branchId
              } = action.profile;
            return {...state,
                 profileLoaded: true, 
                 userProfile : newProfile, 
                 originalProfile: newProfile, 
                 employers : employers || [],
                 incomes: incomes || [],
                 branchId: branchId
                }; 
        case profileConstants.SAVE_PROFILE_SUCCESS:
            return {userProfile: action.profile, profileLoaded: true, originalProfile: action.profile}
        case profileConstants.SAVE_LANGUAGE:
            return state; 
        case profileConstants.EDIT_PROFILE_UPDATE:
            return { ...state, userProfile: action.profile };
        case profileConstants.LOAD_PROFILE_START:
            return { ...state, profileLoaded: false };
        case profileConstants.SAVE_EXTENDED_PROFILE_START:
            return { ...state, savingExtendedProfile: true };
        case profileConstants.SAVE_EXTENDED_PROFILE_SUCCESS:
            return { ...state, savingExtendedProfile: false };
        case profileConstants.TOGGLE_LANGUAGE_SUCCESS:
                const {originalProfile,userProfile} = state;
                originalProfile.selectedLanguage = action.selectedLanguage;
                userProfile.selectedLanguage = action.selectedLanguage;
            return { ...state, savingExtendedProfile: false , originalProfile, userProfile};
        case profileConstants.CLEAN_PROFILE_STATE:
            return { ...profileIntitalState };
        default: 
            return state; 
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/profile.reducer.js